export enum DataFormat {
    CSV
}